import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

function CallDuration({ className }) {
  const { duration } = useSelector(store => store.telephony);

  return (
    <span className={className}>{duration ? moment(duration).format('mm:ss') : '00:00'}</span>
  );
}

export default CallDuration;
